module.exports = __webpack_public_path__ + "static/img/u101526.d6e8ef3d.png";